import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import AppCard from "../components/AppCard";
import { db } from "../services/firebase";

function AppsPage({ user }) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadApps = async () => {
      if (!user?.uid) {
        setApps([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError("");
      try {
        const appsQuery = query(collection(db, "users", user.uid, "apps"), orderBy("updatedAt", "desc"));
        const snapshot = await getDocs(appsQuery);
        setApps(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        setError(err.message || "Failed to load apps from Firestore.");
      } finally {
        setLoading(false);
      }
    };

    loadApps();
  }, [user?.uid]);

  return (
    <div className="grid" style={{ gap: "16px" }}>
      <div className="section-header">
        <h2 className="section-header__title">Saved apps</h2>
        <button className="button">New app</button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="grid grid--two">
        {loading && <p className="muted">Loading apps...</p>}
        {!loading && apps.length === 0 && <p className="muted">No apps saved yet.</p>}
        {!loading &&
          apps.map((app) => (
            <AppCard key={app.id} app={app} />
          ))}
      </div>
    </div>
  );
}

export default AppsPage;
